import { render, staticRenderFns } from "./CustomerService.vue?vue&type=template&id=66395c39&scoped=true"
import script from "./CustomerService.vue?vue&type=script&lang=ts"
export * from "./CustomerService.vue?vue&type=script&lang=ts"
import style0 from "./CustomerService.vue?vue&type=style&index=0&id=66395c39&prod&scoped=true&lang=css"
import style1 from "./CustomerService.vue?vue&type=style&index=1&id=66395c39&prod&scoped=true&lang=scss"
import style2 from "./CustomerService.vue?vue&type=style&index=2&id=66395c39&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_169bdbd7e32539014db8c98595250064/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66395c39",
  null
  
)

export default component.exports